import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { updateCustomer } from "../services/authenticatedRequests";
import { toast } from "react-toastify";

const EditProfileModal = ({ isOpen, onClose, customer }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    displayName: "",
    phoneNumber: "",
    email: "",
    userName: ""
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (customer) {
      setFormData({
        firstName: customer.firstName || "",
        lastName: customer.lastName || "",
        displayName: customer.displayName || "",
        phoneNumber: customer.phoneNumber || "",
        email: customer.email || "",
        userName: customer.userName || ""
      });
    }
  }, [customer]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Only editable fields will be updated; email and username remain unchanged.
      await updateCustomer({
        firstName: formData.firstName,
        lastName: formData.lastName,
        displayName: formData.displayName,
        phoneNumber: formData.phoneNumber,
        email: formData.email,
        userName: formData.userName
      });
        toast.success("Profile updated successfully.");
      onClose();
      window.location.reload(); // Reload the page to reflect changes
    } catch (error) {
      console.error("Error updating profile:", error.message);
        toast.error("Error updating profile. Please try again.");
      // Optionally, display a notification here
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div
      className="modal d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog">
        <div
          className="modal-content p-24 border border-gray-100 hover-border-main-600 transition-1 rounded-8"
          style={{ borderRadius: "0" }}
        >
          <button
            onClick={onClose}
            className="close-btn absolute  text-sm text-gray-700 ms-auto"
          >
            ×
          </button>
          <div className="modal-header border-0 p-0 mb-10">
            <h6 className="modal-title text-sm text-neutral-900 fw-semibold">
              Edit Profile
            </h6>
          </div>
          <div className="modal-body p-0">
            <form onSubmit={handleSubmit}>
              {[
                { label: "First Name", name: "firstName", required: true, disabled: false },
                { label: "Last Name", name: "lastName", required: true, disabled: false },
                { label: "Display Name", name: "displayName", required: true, disabled: false },
                { label: "Phone Number", name: "phoneNumber", required: false, disabled: false },
                { label: "Email", name: "email", required: true, disabled: true },
                { label: "User Name", name: "userName", required: true, disabled: true }
              ].map((field, index) => (
                <div className="mb-4" key={index}>
                  <label className="block text-gray-600 mb-1 text-sm">
                    {field.label}
                  </label>
                  <input
                    type={field.name === "email" ? "email" : "text"}
                    name={field.name}
                    className="common-input-two w-full text-sm"
                    value={formData[field.name]}
                    onChange={handleChange}
                    required={field.required}
                    disabled={field.disabled}
                  />
                </div>
              ))}
              <button
                type="submit"
                className="btn btn-main btn-sm"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Changes"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export default EditProfileModal;
